import { useState } from "react";
import { createContainer } from "unstated-next";

export interface ILoading {
  isloading: boolean;
  start: () => void;
  done: () => void;
}

const useLoadingContainer = () => {
  const [loadingState, handleLoading] = useState<boolean>(false);
  const loading: ILoading = {
    isloading: loadingState,
    start: () => handleLoading(true),
    done: () => handleLoading(false)
  };

  return loading;
};

export const LoadingContainer = createContainer(useLoadingContainer);
